import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Heart, Shield, Users, Award } from 'lucide-react';
export function About() {
  return <div className="bg-white min-h-screen pb-20" data-id="element-164">
      {/* Hero */}
      <div className="relative bg-warm-900 text-white py-24 lg:py-32 overflow-hidden" data-id="element-165">
        <div className="absolute inset-0" data-id="element-166">
          <img src="https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Transportation fleet" className="w-full h-full object-cover" data-id="element-167" />
          <div className="absolute inset-0 bg-warm-900/75" data-id="element-168"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-169">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-id="element-170">
            Our Commitment to Reliable Transportation
          </h1>
          <p className="text-xl text-warm-200 max-w-3xl mx-auto" data-id="element-171">
            Gozie Shipping and Transportation is dedicated to providing
            dependable and affordable transportation solutions for individuals,
            families, and businesses.
          </p>
        </div>
      </div>

      {/* Our Story */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-172">
        <div className="flex flex-col-reverse lg:flex-row gap-16 items-center" data-id="element-173">
          <div className="lg:w-1/2" data-id="element-174">
            <h2 className="text-3xl font-bold text-warm-900 mb-6" data-id="element-175">Our Story</h2>
            <div className="space-y-4 text-lg text-warm-600" data-id="element-176">
              <p data-id="element-177">
                Gozie Shipping and Transportation is dedicated to providing
                dependable and affordable transportation solutions for
                individuals, families, and businesses. Our goal is to ensure
                that everyone—especially individuals with mobility
                challenges—has access to safe and comfortable transportation.
              </p>
              <p data-id="element-178">
                We believe transportation should never be a barrier. That is why
                our services are designed to provide convenience, reliability,
                and affordability for every customer we serve.
              </p>
              <p data-id="element-179">
                With experienced drivers, well-maintained vehicles, and a strong
                commitment to customer care, we ensure every trip or delivery is
                handled with professionalism and respect.
              </p>
              <p className="font-medium text-primary-700" data-id="element-180">
                Our mission is to make transportation accessible, reliable, and
                affordable for everyone. We are committed to supporting our
                community by providing services that improve mobility,
                independence, and convenience.
              </p>
            </div>
          </div>
          <div className="lg:w-1/2" data-id="element-181">
            <div className="grid grid-cols-2 gap-4" data-id="element-182">
              <img src="https://cdn.magicpatterns.com/uploads/jUcrX2CyRxQeTAvsM8brJi/pexels-yankrukov-8617515.jpg" alt="Children on school run pickup" className="rounded-xl shadow-md w-full h-64 object-cover" data-id="element-183" />
              <img src="https://cdn.magicpatterns.com/uploads/1TErWRQks7zxg4od6XAqWM/pexels-mingao-welfarecar-555708794-24415252_(1).jpg" alt="Wheelchair accessible vehicle with ramp" className="rounded-xl shadow-md w-full h-64 object-cover mt-8" data-id="element-184" />
            </div>
          </div>
        </div>
      </div>

      {/* Core Values */}
      <div className="bg-warm-50 py-20" data-id="element-185">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-186">
          <div className="text-center mb-16" data-id="element-187">
            <h2 className="text-3xl font-bold text-warm-900 mb-4" data-id="element-188">
              Our Core Values
            </h2>
            <p className="text-lg text-warm-600 max-w-2xl mx-auto" data-id="element-189">
              These principles guide every decision we make and every ride we
              provide.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-190">
            <Card className="border-none shadow-md text-center" data-id="element-191">
              <CardBody className="p-8" data-id="element-192">
                <Heart className="w-12 h-12 text-primary-600 mx-auto mb-4" data-id="element-193" />
                <h3 className="text-xl font-bold text-warm-900 mb-3" data-id="element-194">
                  Affordability
                </h3>
                <p className="text-warm-600 text-sm" data-id="element-195">
                  We maintain the most competitive rates in the industry because
                  we believe essential mobility shouldn't be a financial burden.
                </p>
              </CardBody>
            </Card>
            <Card className="border-none shadow-md text-center" data-id="element-196">
              <CardBody className="p-8" data-id="element-197">
                <Shield className="w-12 h-12 text-primary-600 mx-auto mb-4" data-id="element-198" />
                <h3 className="text-xl font-bold text-warm-900 mb-3" data-id="element-199">
                  Safety First
                </h3>
                <p className="text-warm-600 text-sm" data-id="element-200">
                  From rigorous vehicle maintenance to secure equipment shipping
                  protocols, safety is never compromised for price.
                </p>
              </CardBody>
            </Card>
            <Card className="border-none shadow-md text-center" data-id="element-201">
              <CardBody className="p-8" data-id="element-202">
                <Award className="w-12 h-12 text-primary-600 mx-auto mb-4" data-id="element-203" />
                <h3 className="text-xl font-bold text-warm-900 mb-3" data-id="element-204">
                  Reliability
                </h3>
                <p className="text-warm-600 text-sm" data-id="element-205">
                  We understand that medical appointments are critical. We show
                  up on time, every time.
                </p>
              </CardBody>
            </Card>
            <Card className="border-none shadow-md text-center" data-id="element-206">
              <CardBody className="p-8" data-id="element-207">
                <Users className="w-12 h-12 text-primary-600 mx-auto mb-4" data-id="element-208" />
                <h3 className="text-xl font-bold text-warm-900 mb-3" data-id="element-209">
                  Community
                </h3>
                <p className="text-warm-600 text-sm" data-id="element-210">
                  We are proud partners in our local healthcare ecosystem,
                  actively supporting disability advocacy.
                </p>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>

      {/* The Team */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-211">
        <div className="text-center mb-16" data-id="element-212">
          <h2 className="text-3xl font-bold text-warm-900 mb-4" data-id="element-213">
            The People Behind the Wheel
          </h2>
          <p className="text-lg text-warm-600 max-w-2xl mx-auto" data-id="element-214">
            Our drivers are the heart of Gozie Transportation. They aren't just
            drivers; they are trained care professionals and logistics experts.
          </p>
        </div>

        <div className="bg-primary-900 rounded-3xl overflow-hidden shadow-2xl flex flex-col-reverse lg:flex-row" data-id="element-215">
          <div className="lg:w-1/2 p-12 lg:p-16 flex flex-col justify-center text-white" data-id="element-216">
            <h3 className="text-2xl font-bold mb-6" data-id="element-217">
              Rigorous Training Standards
            </h3>
            <ul className="space-y-4" data-id="element-218">
              <li className="flex items-start" data-id="element-219">
                <Shield className="w-6 h-6 text-primary-300 mr-4 flex-shrink-0" data-id="element-220" />
                <span data-id="element-221">
                  Comprehensive background checks and regular drug screening
                </span>
              </li>
              <li className="flex items-start" data-id="element-222">
                <Heart className="w-6 h-6 text-primary-300 mr-4 flex-shrink-0" data-id="element-223" />
                <span data-id="element-224">CPR, First Aid, and Defensive Driving Certification</span>
              </li>
              <li className="flex items-start" data-id="element-225">
                <Users className="w-6 h-6 text-primary-300 mr-4 flex-shrink-0" data-id="element-226" />
                <span data-id="element-227">
                  PASS (Passenger Assistance Safety and Sensitivity) Certified
                </span>
              </li>
              <li className="flex items-start" data-id="element-228">
                <Award className="w-6 h-6 text-primary-300 mr-4 flex-shrink-0" data-id="element-229" />
                <span data-id="element-230">
                  Specialized training in wheelchair securement and lift
                  operation
                </span>
              </li>
            </ul>
          </div>
          <div className="lg:w-1/2" data-id="element-231">
            <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Professional driver smiling" className="w-full h-full object-cover min-h-[400px]" data-id="element-232" />
          </div>
        </div>
      </div>

      {/* FAQ CTA Section */}
      <div className="bg-warm-50 py-16" data-id="element-233">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-234">
          <h2 className="text-3xl font-extrabold text-black mb-4" data-id="element-235">
            Have Questions?
          </h2>
          <p className="text-warm-700 text-lg mb-8 max-w-2xl mx-auto" data-id="element-236">
            Find answers to common questions about our services, pricing,
            booking process, and accessibility features.
          </p>
          <Link to="/faq" data-id="element-237">
            <Button size="lg" variant="primary" className="px-8 py-4 text-lg" data-id="element-238">
              View Frequently Asked Questions
            </Button>
          </Link>
        </div>
      </div>
    </div>;
}